import { render } from "./CustomPerfil.vue?vue&type=template&id=b7768402&scoped=true"
import script from "./CustomPerfil.vue?vue&type=script&lang=js"
export * from "./CustomPerfil.vue?vue&type=script&lang=js"

import "./CustomPerfil.vue?vue&type=style&index=0&id=b7768402&scoped=true&lang=css"

import exportComponent from "/workspace/projectes/suggestions/suggeriments-upcommons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7768402"]])

export default __exports__